import React, { useState } from "react";
import logo from "../../assets/logo.png";
import { GiHamburgerMenu } from "react-icons/gi";
import ConsultationModal from "../Modal/ConsultationModal";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  return (
    <>
      <nav className="w-full px-4 py-4 shadow-lg bg-white sticky top-0 z-50">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <a href="#home" className="flex items-center">
            <img src={logo} alt="GDesk" className="h-10 w-auto" />
            <span className="text-xl font-semibold text-primary ml-2">
              GDesk
            </span>
          </a>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center gap-8 text-primary">
            <a href="#home" className="hover:underline">
              Home
            </a>
            <a href="#service" className="hover:underline">
              Services
            </a>
            <a href="#about" className="hover:underline">
              About Us
            </a>
            <a href="#faq" className="hover:underline">
              FAQ
            </a>
            <a href="#contact" className="hover:underline">
              Contact
            </a>

            <button
              onClick={() => setOpenModal(true)}
              className="bg-primary text-white px-5 py-2 rounded-md shadow border border-primary hover:bg-white hover:text-primary transition"
            >
              Book a Call
            </button>
          </div>

          {/* Hamburger Icon */}
          <div className="md:hidden">
            <button onClick={() => setIsOpen(!isOpen)}>
              {" "}
              <GiHamburgerMenu />{" "}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="md:hidden mt-4 flex flex-col text-center gap-4 text-primary">
            <a href="#home" className="md:text-sm">
              Home
            </a>
            <a href="#service" className="md:text-sm">
              Services
            </a>
            <a href="#about" className="md:text-sm">
              About Us
            </a>
            <a href="#faq" className="md:text-sm">
              FAQ
            </a>
            <a href="#contact" className="md:text-sm">
              Contact
            </a>

            <button className="md:text-sm bg-primary text-white px-5 py-2 rounded-md shadow border border-primary hover:bg-white hover:text-primary transition">
              Book a Call
            </button>
          </div>
        )}
      </nav>

      <ConsultationModal
        isOpen={openModal}
        onClose={() => setOpenModal(false)}
      />
    </>
  );
};

export default Navbar;
